import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    NO_CHANGE,
} from 'one-state-subject/src/types';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {
    setProvidersAction
} from '../../../../../../_local/one-state-provider-athena/src/actions';
import { format } from 'one-util-date';

export const enum Types {
    GETALLPROVIDERS_FETCH = "get-all-providers-fetch/athena",
    SETSELECTED_ATHENA = 'one-state-subject/setselected-athena',
}

/**
 * This function will fetch all providers
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchGetAllProvidersAthena = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server, log, agentId, teamName, settings: {
            athenaendpoints: {
                getproviderinfo
            },
            compatible: { consolidated_api_invocation, contact_center_type },
        } } = context;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(Types.GETALLPROVIDERS_FETCH,Types.SETSELECTED_ATHENA),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                const callGetAllProvidersAPI = () => {
                    let headers = new Headers();
                    const responsefromAPI = server.get({
                        headers: headers,
                        path: getproviderinfo
                    })
                        .then((responsegetallproviders: any) => responsegetallproviders)
                        .catch((getallprovidersres: any) => {
                            log.error(
                                "ccw-gadget,getallproviders-athena",
                                "getallproviders-athena", {
                                    getallprovidersres
                                }
                            );
                            let errorbuild: ErrorObject = {
                                source: "GetAllProviders",
                                type: "error",
                                status: getallprovidersres?.status,
                                erroritems: getallprovidersres?.errors,
                                error_date: errorDate,
                                error_time: errorTime
                            };
                            return errorbuild;
                        })
                    log.debug(
                        "ccw-gadget,getallproviders-athena",
                        "getallproviders-athena response", {
                            responsefromAPI
                        });
                    return from(responsefromAPI)
                }
                //Calling callGetAllProvidersAPI function here
                //the reason is we need to use pipe function.
                return callGetAllProvidersAPI().
                    pipe(
                        map((responsereceived: any) => TransformResponse(responsereceived, context))).
                    pipe(
                        flatMap(responseAfterTransform => {
                            const actions: any = [];
                            if (responseAfterTransform.error) {
                                actions.push(addAction(responseAfterTransform.error));
                            } else {
                                actions.push(setProvidersAction(responseAfterTransform.providers));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);

